import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import {
    createAPIEndpointReports,
    EndpointReports,
} from "../../../Services/ReportsAll/GrnDataExcelService";
import storage from "../../../Services/Storage";
import { toast } from "react-toastify";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";

const CustomerMetricReport = () => {
    const [loadingExcel, setLoadingExcel] = useState(false);
    const auth = storage.getLocal("user");

    const handleExportExcel = async () => {
        let uniqueNo = `CustomerMetricReport${GetDateFormat()}.xlsx`;
        setLoadingExcel(true);
        createAPIEndpointReports()
            .get(`${EndpointReports.custmetricreport}?CompId=${auth.CompId}`)
            .then((response) => {
                if (response.data.length > 0) {
                    downloadExcel(response.data, uniqueNo);
                    setLoadingExcel(false);
                } else {
                    toast.warning("No Data Found.", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                    setLoadingExcel(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setLoadingExcel(false);
            });
    };

    return (
        <main>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Customer Metric Report</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <section className="sales-box">
                    <div className="">
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <img src={require("../../../Assets/Images/metrics.png")} style={{ width: "90%" }} />
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <p style={{ fontSize: "16px" }}>Process : <b>Customer Metric</b></p>
                                <button
                                    type="button"
                                    className="btn btn-primary mt-2"
                                    onClick={handleExportExcel}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Download"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
};

export default CustomerMetricReport;
